<template>
  <div class="field">
    <Field
      :name="id"
      :rules="rules"
      v-slot="{ field, errors }"
      :modelValue="modelValue"
      :validateOnInput="true"
    >      

      <label v-if="label" class="label" :for="id">
        <span v-html="label"></span>
        <RequiredAsterisk v-if="rules.includes('required')" />
      </label>

      <div class="control">

        <textarea
          class="textarea"
          autocomplete="off"
          :class="{ 'is-danger': !!errors.length }"
          :id="id"
          v-bind="field"
          :disabled="disabled"
          :maxlength="maxlength"
          :placeholder="placeholder"
          :aria-invalid="!!errors.length"
          :aria-errormessage="`${id}Err`"
          @input="updateValue($event.target.value, field)"
        />

        <p v-if="errors.length" class="help is-danger" :id="`${id}Err`">
          {{ errors[0] }}
        </p>

      </div>

      
    </Field>
  </div>
</template>

<script>
import { Field } from 'vee-validate';
import RequiredAsterisk from '@/components/forms/required-asterisk.vue';

export default {
  name: 'TextAreaElement',
  props: {
    id: {
      type: String,
      required: true,
      validator: value => value.length,
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 4096 // Standard InChI can be very long
    },
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value);
    },
  },
  components: {
    RequiredAsterisk,
    Field,
  },
};
</script>